<template>
  <div>
    <Head></Head>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item class="dqwz">当前位置：</el-breadcrumb-item>
      <el-breadcrumb-item class="home" :to="{ path: '/' }"
        >首页</el-breadcrumb-item
      >
      <el-breadcrumb-item class="">报名</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row class="tac">
      <Process></Process>
      <el-col :span="18" class="conter">
        <div class="enroll">
          <h2>{{news_name}}</h2>
          <div class="from_box">
            <div class="from_box_top">
              <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                class="demo-formData"
                ><div class="item_top">
                  <el-form-item label="姓名:" prop="real_name">
                    <el-input v-model="formData.real_name"></el-input>
                  </el-form-item>
                  <el-form-item label="性别:" prop="sex">
                    <el-select v-model="formData.sex" placeholder="请选择">
                      <el-option
                        v-for="item in sex_list"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="民族:" prop="nation">
                    <el-select v-model="formData.nation" placeholder="请选择">
                      <el-option
                        v-for="item in nation_list"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="籍贯:" prop="native_place">
                    <el-input v-model="formData.native_place"></el-input>
                  </el-form-item>
                  <el-form-item label="出生年月日:" prop="birth_date">
                    <el-input
                      v-model="formData.birth_date"
                      placeholder="1970-01-01"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="婚姻情况:" prop="marriage">
                    <el-select v-model="formData.marriage" placeholder="请选择">
                      <el-option
                        v-for="item in marriage_list"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="政治面貌:" prop="face">
                    <el-select v-model="formData.face" placeholder="请选择">
                      <el-option
                        v-for="item in face_list"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="最高学历:" prop="education">
                    <el-select
                      v-model="formData.education"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in education_list"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="联系电话:" prop="mobile">
                    <el-input v-model="formData.mobile"></el-input>
                  </el-form-item>
                <!-- </div>
                <div class="item_botm"> -->
                  <el-form-item label="身份证号码:" prop="id_card">
                    <el-input v-model="formData.id_card"></el-input>
                  </el-form-item>
                  <el-form-item label="通讯地址:" prop="mail_address">
                    <el-input v-model="formData.mail_address"></el-input>
                  </el-form-item>
                  <el-form-item label="报名岗位:" prop="post_name">
                    <el-select v-model="formData.post_name" placeholder="请选择" @change="setPostCode">
                      <el-option
                          v-for="job_item in jobList"
                          :key="job_item.id"
                          :label="job_item.name"
                          :value="job_item.name"
                        >
                        </el-option>
                    </el-select>

                  </el-form-item>
                  <el-form-item label="岗位代码:" prop="post_code">
                    <el-input v-model="formData.post_code" readonly></el-input>
                  </el-form-item>
                  <el-form-item label="现工作单位及岗位:" prop="current_unit">
                    <el-input v-model="formData.current_unit"></el-input>
                  </el-form-item>
                  <el-form-item label="职（执）业 资格证书:" prop="vocation">
                    <el-input v-model="formData.vocation"></el-input>
                  </el-form-item>
                  <el-form-item label="专业技术职称：" prop="tech_title">
                    <el-input v-model="formData.tech_title"></el-input>
                  </el-form-item>
                  <el-form-item label="期望税前月薪：" prop="hope_salary">
                    <el-input v-model.number="formData.hope_salary"></el-input>
                  </el-form-item>
                </div>
              </el-form>
            </div>
            <div class="from_box_centent">
              <h3>教育经历（高中起）</h3>
              <div>
              <ul
                class="box_centent_ul"
                v-for="(item, index) in formData.user_education_relation"
                :key="index"
              >
                <li>
                  <span>*</span><span>起止时间：</span>
                  <input type="text" v-model="item.start_and_end_date" placeholder="2020.9-2024.6" />
                </li>
                <li>
                  <span>*</span><span>毕业院校：</span>
                  <input type="text" v-model="item.school" placeholder="请填写毕业院校全称"  />
                </li>
                <li>
                  <span>*</span><span>所属专业：</span>
                  <input type="text" v-model="item.major" placeholder="请与毕业证书上专业名称保持完全一致"  />
                </li>
                <li>
                  <span>*</span><span>学历：</span>

                  <el-select v-model="item.education_id" placeholder="请选择">
                    <el-option
                      v-for="education_item in education_list"
                      :key="education_item.id"
                      :label="education_item.name"
                      :value="education_item.id"
                    >
                    </el-option>
                  </el-select>
                </li>
                <li>
                  <span>*</span><span>学制：</span>
                  <el-select v-model="item.school_system" placeholder="请选择">
                  <el-option
                      v-for="education_item in education_year"
                      :key="education_item.id"
                      :label="education_item.name"
                      :value="education_item.name"
                    >
                    </el-option>
                  </el-select>
                </li>

                  <div class="tianjia delList" @click="delLine('user_education_relation',index)" v-if="index > 0">删除</div>

              </ul>
              </div>
              <div class="tianjia" @click="adduser_education_relation()">+</div>
              <h3>主要工作经历</h3>
              <div>
              <ul
                class="box_centent_uls"
                v-for="(item, index) in formData.user_work_exp_relation"
                :key="index"
              >
                <li>
                  <span></span><span>起止时间：</span>
                  <input type="text" v-model="item.start_and_end_date"  placeholder="2020.9-2024.6" />
                </li>
                <li>
                  <span></span><span>工作单位：</span>
                  <input type="text" v-model="item.work_unit"  placeholder="请输入公司名称全称" />
                </li>
                <li>
                  <span></span><span>职务：</span>
                  <input type="text" v-model="item.job"  placeholder="岗位职务" />
                </li>
                <li>
                  <span></span><span>证明人：</span>
                  <input type="text" v-model="item.witness"  placeholder="联系人姓名" />
                </li>
                <li>
                  <span></span><span>证明人联系方式：</span>
                  <input type="text" v-model="item.witness_phone"  placeholder="手机号" />
                </li>
                <div class="tianjia delList" @click="delLine('user_work_exp_relation',index)" v-if="index > 0">删除</div>
              </ul>
              </div>
              <div class="tianjia" @click="adduser_work_exp_relation()">+</div>
              <h3>
                亲属关系情况
                <p>
                  （若有亲人或朋友现在或曾经任职于报名单位？如有，请详细说明）
                </p>
              </h3>
              <div>
              <ul
                class="self_relation_ul"
                v-for="(item, index) in formData.user_family_relation"
                :key="index"
              >
                <li>
                  <span></span><span>姓名：</span>
                  <input type="text" v-model="item.full_name" />
                </li>
                <li>
                  <span></span><span>单位名称：</span>
                  <input type="text" v-model="item.unit_name" />
                </li>
                <li>
                  <span></span><span>职务：</span>
                  <input type="text" v-model="item.job" />
                </li>
                <li>
                  <span></span><span>部门：</span>
                  <input type="text" v-model="item.department" />
                </li>
                <li>
                  <span></span><span>与本人关系：</span>
                  <input type="text" v-model="item.self_relation" />
                </li>
                <div class="tianjia delList" @click="delLine('user_family_relation',index)" v-if="index > 0">删除</div>
              </ul>
              </div>
              <div class="tianjia" @click="adduser_family_relation()">+</div>
              <h3>
                上传图片
                <p>(图片大小请控制在5M以内)</p>
              </h3>
              <ul class="uploader_ul">
                <li>
                  <div class="li_img_box">
                    <el-upload
                      action=""
                      list-type="picture-card"
                      :auto-upload="false"
                      :on-change="handleChange1"
                      accept=".jpg,.jpeg,.png,.JPG,.JPEG"
                      :on-remove="handleRemove1"
                      :file-list="filelist1"
                    >
                      <i class="el-icon-plus" />
                    </el-upload>
                  </div>

                  <p><span>*</span><span>身份证正</span></p>
                </li>
                <li>
                  <div class="li_img_box">
                    <el-upload
                      action=""
                      list-type="picture-card"
                      :auto-upload="false"
                      :on-change="handleChange2"
                      accept=".jpg,.jpeg,.png,.JPG,.JPEG"
                      :on-remove="handleRemove2"
                      :file-list="filelist2"
                    >
                      <i class="el-icon-plus" />
                    </el-upload>
                  </div>

                  <p><span>*</span><span>身份证反</span></p>
                </li>
                <li>
                  <div class="li_img_box">
                    <el-upload
                      action=""
                      list-type="picture-card"
                      :auto-upload="false"
                      :on-change="handleChange3"
                      accept=".jpg,.jpeg,.png,.JPG,.JPEG"
                      :on-remove="handleRemove3"
                      :file-list="filelist3"
                    >
                      <i class="el-icon-plus" />
                    </el-upload>
                  </div>

                  <p><span>*</span><span>一寸彩照</span></p>
                </li>
                <li>
                  <div class="li_img_box">
                    <el-upload
                      action=""
                      list-type="picture-card"
                      :auto-upload="false"
                      :on-change="handleChange4"
                      accept=".jpg,.jpeg,.png,.JPG,.JPEG"
                      :on-remove="handleRemove4"
                      :file-list="filelist4"
                    >
                      <i class="el-icon-plus" />
                    </el-upload>
                  </div>

                  <p><span>*</span><span>学历证书</span></p>
                </li>
                <li>
                  <div class="li_img_box">
                    <el-upload
                      action=""
                      list-type="picture-card"
                      :auto-upload="false"
                      :on-change="handleChange5"
                      accept=".jpg,.jpeg,.png,.JPG,.JPEG"
                      :on-remove="handleRemove5"
                      :file-list="filelist5"
                    >
                      <i class="el-icon-plus" />
                    </el-upload>
                  </div>
                  <p><span></span><span>其他证件</span></p>
                </li>
                <li>
                  <div class="li_img_box">
                    <el-upload
                      action=""
                      list-type="picture-card"
                      :auto-upload="false"
                      :on-change="handleChange6"
                      accept=".jpg,.jpeg,.png,.JPG,.JPEG"
                      :on-remove="handleRemove6"
                      :file-list="filelist6"
                    >
                      <i class="el-icon-plus" />
                    </el-upload>
                  </div>
                  <p><span></span><span>其他证件</span></p>
                </li>
              </ul>
            </div>

            <el-button
              class="sub"
              type="primary"
              @click="submitForm('formData')"
              >{{ isedit == 1 ? "修改报名" : "提交报名" }}</el-button
            >
          </div>
        </div>
      </el-col>
    </el-row>
    <br><br>
    <Footer></Footer>

    <el-dialog
      title="提示"
      :visible.sync="showPopup"
      width="675px">
      <div class="popup-content">

        <h3 style="padding-bottom: 10px">报名须知</h3>
        {{popup_notice}}
        <br><br>
        <h3 style="padding-bottom: 10px">诚信承诺书</h3>
        {{popup_integrity_undertaking}}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showPopup=false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Head from "./Head";
import Footer from "./Footer";
import Process from "./Process";
export default {
  props: {},
  data() {
    return {
      isedit: 0,
      news_name: "",
      showPopup: false,
      popup_notice: "",
      popup_integrity_undertaking: "",
      nation_list: [],
      education_list: [],
      education_year: [{id:1,name:"全日制"},{id:2,name:"非全日制"}],
      face_list: [],
      marriage_list: [
        { id: 1, name: "已婚" },
        { id: 2, name: "未婚" },
      ],
      sex_list: [
        { id: 1, name: "男" },
        { id: 2, name: "女" },
      ],
      filelist1: [],
      filelist2: [],
      filelist3: [],
      filelist4: [],
      filelist5: [],
      filelist6: [],
      filesize1: 0,
      filesize2: 0,
      filesize3: 0,
      filesize4: 0,
      filesize5: 0,
      filesize6: 0,
      formData: {
        post_id: "",
        company_id: "",
        real_name: "",
        nation: "",
        sex: "",
        native_place: "",
        birth_date: "",
        marriage: "",
        face: "",
        education: "",
        mobile: "",
        id_card: "",
        mail_address: "",
        post_name: "",
        post_code: "",
        current_unit: "",
        vocation: "",
        tech_title: "",
        hope_salary: "",
        user_education_relation: [
          {
            id: "",
            start_and_end_date: "",
            school: "",
            major: "",
            school_system: "",
            education_id: "",
          },
        ],
        user_work_exp_relation: [
          {
            id: "",
            start_and_end_date: "",
            work_unit: "",
            job: "",
            witness: "",
            witness_phone: "",
          },
        ],
        user_family_relation: [
          {
            id: "",
            full_name: "",
            unit_name: "",
            job: "",
            department: "",
            self_relation: "",
          },
        ],
        front_of_id_card: "",
        back_of_id_card: "",
        id_photo: "",
        diploma_cert: "",
        other_cert_one: "",
        other_cert_two: "",
      },
      rules: {
        real_name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 10 个字符",
            trigger: "blur",
          },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
        nation: [{ required: true, message: "请输入民族", trigger: "blur" }],
        native_place: [
          { required: true, message: "请输入籍贯", trigger: "blur" },
        ],
        birth_date: [
          { required: true, message: "请输入出生年月日", trigger: "blur" },
        ],
        marriage: [
          { required: true, message: "请输入婚姻情况", trigger: "blur" },
        ],
        face: [{ required: true, message: "请输入政治面貌", trigger: "blur" }],
        education: [
          { required: true, message: "请输入最高学历", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请输入电话号码", trigger: "blur" },
          { required: true, message: "请输入zqd电话号码", trigger: "blur" },
        ],
        id_card: [
          { required: true, message: "请输入身份证号码", trigger: "blur" },
          { min: 18, max: 18, message: "身份证号码长度18位", trigger: "blur" },
        ],
        mail_address: [
          { required: true, message: "请输入通讯地址", trigger: "blur" },
        ],
        post_name: [
          { required: true, message: "请输入所需报名的岗位", trigger: "blur" },
        ],
        post_code: [
          {
            required: true,
            message: "请输入所需报名的岗位代码",
            trigger: "blur",
          },
        ],
        // current_unit: [
        //   {
        //     required: true,
        //     message: "请输入现工作单位及岗位",
        //     trigger: "blur",
        //   },
        // ],
        // vocation: [
        //   { required: true, message: "请输入职业资格证书", trigger: "blur" },
        // ],
        // tech_title: [
        //   { required: true, message: "请输入专业技术职称", trigger: "blur" },
        // ],
        // hope_salary: [
        //   { required: true, message: "请输入期望税前月薪", trigger: "blur" },
        //   { type: 'number', message: '期望税前月薪必须为数字', trigger: 'blur' },
        // ],
        // front_of_id_card: [
        //   { required: true, message: "请上传身份证正面", trigger: "blur" },
        // ],
        // back_of_id_card: [
        //   { required: true, message: "请上传身份证反面", trigger: "blur" },
        // ],
        // id_photo: [
        //   { required: true, message: "请上传证件照", trigger: "blur" },
        // ],
        // diploma_cert: [
        //   { required: true, message: "请上传学历证书", trigger: "blur" },
        // ],

      },
      jobList:[],
    };
  },
  computed: {},
  created() {
    console.log("this.created");
    // this.getJobList();
  },
  async mounted() {
    var query = this.$route.query;
    this.formData.post_id = query.post_id;
    this.formData.new_open_id = query.post_id;
    await this.getPersonalDetails(this.formData.post_id);

    var isedit = query.isedit;
    if (isedit == 1) {
      // 修改
      this.isedit = 1;
    }else{
      //报名的时候弹出须知
      this.getPopup()
    }
  },
  watch: {},
  methods: {
    // 获得岗位列表
    getJobList(){
      this.request("api/index/list",{nav_id:3},"get").then(res =>{
        // console.log("this.joblist",res.data.data.exam_list.data);
        this.jobList = res.data.data.exam_list.data;
      })
    },
    setPostCode(vars){
      console.log("select vars",vars);
      this.jobList.forEach(item =>{
        if(item.name == vars) {
          this.formData.post_code = item.code;
          this.formData.new_open_id = item.id;
        }
        console.log("this.formData.new_open_id",this.formData.new_open_id);
      })

    },
    // 获得用户详情
    getPersonalDetails(id) {
      let _this = this;
      _this
        .request("api/sign_up/personal_details", { post_id: id }, "get")
        .then((res) => {
          if (res.data.status == "success") {
            _this.news_name = res.data.data.news_name;
            _this.formData.mobile = res.data.data.mobile;
            _this.formData.real_name = res.data.data.real_name;
            _this.formData.id_card = res.data.data.id_card;
            _this.formData.sex = res.data.data.sex;
            _this.formData.nation = res.data.data.nation ? res.data.data.nation.id : "";
            _this.formData.education = res.data.data.education ? res.data.data.education.id : "";
            _this.formData.face = res.data.data.face ? res.data.data.face.id : "";
            _this.formData.native_place = res.data.data.native_place;
            _this.formData.marriage = res.data.data.marriage;
            _this.formData.birth_date = res.data.data.birth_date;
            _this.formData.mail_address = res.data.data.mail_address;
            _this.formData.current_unit = res.data.data.current_unit;
            _this.formData.tech_title = res.data.data.tech_title;
            _this.formData.hope_salary = res.data.data.hope_salary ? res.data.data.hope_salary : '';
            _this.formData.vocation = res.data.data.vocation;

            // 岗位列表
            _this.jobList = res.data.data.post_list;

            if (res.data.data.front_of_id_card){
              _this.filelist1 = [{url: res.data.data.front_of_id_card}];
              _this.formData.front_of_id_card = res.data.data.front_of_id_card;
            }
            if (res.data.data.back_of_id_card){
              _this.filelist2 = [{url: res.data.data.back_of_id_card}];
              _this.formData.back_of_id_card = res.data.data.back_of_id_card;
            }
            if (res.data.data.id_photo){
              _this.filelist3 = [{url: res.data.data.id_photo}];
              _this.formData.id_photo = res.data.data.id_photo;
            }
            if (res.data.data.diploma_cert){
              _this.filelist4 = [{url: res.data.data.diploma_cert}];
              _this.formData.diploma_cert = res.data.data.diploma_cert;
            }
            if (res.data.data.other_cert_one){
              _this.filelist5 = [{url: res.data.data.other_cert_one}];
              _this.formData.other_cert_one = res.data.data.other_cert_one;
            }
            if (res.data.data.other_cert_two){
              _this.filelist6 = [{url: res.data.data.other_cert_two}];
              _this.formData.other_cert_two = res.data.data.other_cert_two;
            }

            _this.formData.company_id = res.data.data.company_id;
            _this.formData.post_name = res.data.data.post_name;
            _this.formData.post_code = res.data.data.post_code;
            if (res.data.data.user_education_relation.length > 0) {
              _this.formData.user_education_relation =
                res.data.data.user_education_relation;
            }
            if (res.data.data.user_work_exp_relation.length > 0) {
              _this.formData.user_work_exp_relation =
                res.data.data.user_work_exp_relation;
            }
            if (res.data.data.user_family_relation.length > 0) {
              _this.formData.user_family_relation =
                res.data.data.user_family_relation;
            }
            _this.nation_list = res.data.data.nation_list;
            _this.education_list = res.data.data.education_list;
            _this.face_list = res.data.data.face_list;
          }
        });
    },
    sign_up(formData) {
      let _this = this;
      console.log("add",formData);
      // return true
      _this.request("api/sign_up", formData, "signup").then((res) => {
        console.log(res);
        _this.$message.success("报名成功，请等待审核！");
        _this.$router.push("/Step?post_id=" + _this.formData.post_id);
      });
    },
    update_sign_up(formData) {
      let _this = this;
      console.log("edit",formData);
      // return true
      _this.request("api/update_sign_up", formData, "signup").then((res) => {
        console.log(res);
        _this.$message.success("修改成功，请等待审核！");
        _this.$router.push("/Step?post_id=" + _this.formData.new_open_id);
      });
    },

    submitForm(formName) {
      let _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(_this.formData);
          const formData = new FormData();
          Object.keys(_this.formData).forEach((ele) => {
            if (
              ele != "front_of_id_card" &&
              ele != "back_of_id_card" &&
              ele != "id_photo" &&
              ele != "diploma_cert" &&
              ele != "other_cert_one" &&
              ele != "other_cert_two"
            ) {
              if (
                ele == "user_education_relation" ||
                ele == "user_work_exp_relation" ||
                ele == "user_family_relation"
              ) {
                formData.append(ele, JSON.stringify(_this.formData[ele]));
              } else {
                formData.append(ele, _this.formData[ele]);
              }
            }
          });

          if (this.formData.front_of_id_card != "") {
            formData.append("front_of_id_card", this.formData.front_of_id_card);
          }
          if (this.formData.back_of_id_card != "") {
            formData.append("back_of_id_card", this.formData.back_of_id_card);
          }
          if (this.formData.id_photo != "") {
            formData.append("id_photo", this.formData.id_photo);
          }
          if (this.formData.diploma_cert != "") {
            formData.append("diploma_cert", this.formData.diploma_cert);
          }
          if (this.formData.other_cert_one != "") {
            formData.append("other_cert_one", this.formData.other_cert_one);
          }
          if (this.formData.other_cert_two != "") {
            formData.append("other_cert_two", this.formData.other_cert_two);
          }
          console.log(formData);
          //验证图片大小
          if(!this.validateFilesize()){
            return;
          }
          if (this.isedit == 1) {
            _this.update_sign_up(formData);
          } else {
            if(_this.formData.new_open_id){
            formData.post_id = _this.formData.new_open_id;
            formData.delete("new_open_id");
            _this.$delete(_this.formData, "new_open_id");
            }
            _this.sign_up(formData);
          }
        } else {
          _this.$message.error("请检查填写内容！");
          return false;
        }
      });
    },

    //点击后添加事件
    adduser_education_relation() {
      this.formData.user_education_relation.push({
        id: "",
        start_and_end_date: "",
        school: "",
        major: "",
        school_system: "",
        education_id: "",
      });
    },
    adduser_work_exp_relation() {
      this.formData.user_work_exp_relation.push({
        id: "",
        start_and_end_date: "",
        work_unit: "",
        job: "",
        witness: "",
        witness_phone: "",
      });
    },
    adduser_family_relation() {
      this.formData.user_family_relation.push({
        id: "",
        full_name: "",
        unit_name: "",
        job: "",
        department: "",
        self_relation: "",
      });
    },
    // 删除记录
    delLine(type,index){

        this.formData[type].splice(index,1);

    },

    handleRemove1() {
      this.formData.front_of_id_card = "";
    },
    handleChange1(file) {
      const isLt5M = file.size < 1024 * 5000;
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5M!");
        // return false;
      }
      this.filesize1 = file.size
      this.formData.front_of_id_card = file.raw;
    },

    handleRemove2() {
      this.formData.back_of_id_card = "";
    },
    handleChange2(file) {
      const isLt5M = file.size < 1024 * 5000;
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5M!");
        // return false;
      }
      this.filesize2 = file.size
      this.formData.back_of_id_card = file.raw;
    },

    handleRemove3() {
      this.formData.id_photo = "";
    },
    handleChange3(file) {
      const isLt5M = file.size < 1024 * 5000;
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5M!");
        // return false;
      }
      this.filesize3 = file.size
      this.formData.id_photo = file.raw;
    },

    handleRemove4() {
      this.formData.diploma_cert = "";
    },
    handleChange4(file) {
      const isLt5M = file.size < 1024 * 5000;
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5M!");
        // return false;
      }
      this.filesize4 = file.size
      this.formData.diploma_cert = file.raw;
    },

    handleRemove5() {
      this.formData.other_cert_one = "";
    },
    handleChange5(file) {
      const isLt5M = file.size < 1024 * 5000;
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5M!");
        // return false;
      }
      this.filesize5 = file.size
      this.formData.other_cert_one = file.raw;
    },

    handleRemove6() {
      this.formData.other_cert_two = "";
    },
    handleChange6(file) {
      const isLt5M = file.size < 1024 * 5000;
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5M!");
        // return false;
      }
      this.filesize6 = file.size
      this.formData.other_cert_two = file.raw;
    },
    validateFilesize(){
          if (this.formData.front_of_id_card != "") {
            if (this.filesize1 > 1024 * 5000){
              this.$message.error("身份证正面大小不能超过 5M!");
              return false;
            }
          }else{
              this.$message.error("请上传身份证正面！");
              return false;
          }
          if (this.formData.back_of_id_card != "") {
            if (this.filesize2 > 1024 * 5000){
              this.$message.error("身份证反面大小不能超过 5M!");
              return false;
            }
          }else{
              this.$message.error("请上传身份证反面！");
              return false;
          }
          if (this.formData.id_photo != "") {
            if (this.filesize3 > 1024 * 5000){
              this.$message.error("一寸彩照大小不能超过 5M!");
              return false;
            }
          }else{
              this.$message.error("请上传一寸彩照！");
              return false;
          }
          if (this.formData.diploma_cert != "") {
            if (this.filesize4 > 1024 * 5000){
              this.$message.error("学历证书大小不能超过 5M!");
              return false;
            }
          }else{
              this.$message.error("请上传学历证书！");
              return false;
          }
          if (this.formData.other_cert_one != "") {
            if (this.filesize5 > 1024 * 5000){
              this.$message.error("其他证件大小不能超过 5M!");
              return false;
            }
          }
          if (this.formData.other_cert_two != "") {
            if (this.filesize6 > 1024 * 5000){
              this.$message.error("其他证件大小不能超过 5M!");
              return false;
            }
          }
          return true;
    },
    getPopup() {
      let _this = this;
      _this.request("api/index/setting", {key: "popup_setting"}, "get").then((res) => {
        _this.popup_integrity_undertaking = res.data.data.popup_setting.integrity_undertaking;
        _this.popup_notice = res.data.data.popup_setting.notice;
        _this.showPopup = true
      });
    },
  },
  components: {
    Head,
    Footer,
    Process,
  },
};
// 报名
</script>

<style lang="less" scoped>
  .popup-content{
      max-height: 350px;
      overflow-y: auto;
      white-space: pre-wrap;
  }
input {
  height: 40px !important;
}
.conter {
  padding-top: 0.6rem;
  .enroll {
    padding: 0 0.5rem;
    h2 {
      font-size: 0.42rem;
      color: #00a0e9;
      width: 8rem;
      text-align: center;
      margin: 0 auto;
    }
    .from_box {
      margin-top: 1rem;
      .from_box_top {
        .el-form {
          .item_top {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            .el-form-item {
              // width: 33.33%;
              // display: flex;
              width: 23%;
              margin-bottom: 0.5rem;

              // select {
              //   width: 1.63rem;
              //   height: 0.4rem;
              //   border-top: 1px solid #a0a0a0;
              //   outline: medium;
              //   border-radius: 0.05rem;
              // }
            }
          }
          .item_botm {
            display: flex;
            flex-wrap: wrap;
            .el-form-item {
              width: 50%;
              display: flex;
              margin-bottom: 0.5rem;
              .el-form-item__content {
                width: 50%;
              }
            }
          }
        }
      }
      .from_box_centent {
        width: 96%;
        border-top: 1px solid #a0a0a0;
        h3 {
          font-size: 0.29rem;
          color: #000101;
          text-align: center;
          padding: 0.4rem 0;
          p {
            color: #ff0000;
            font-size: 0.21rem;
            text-align: center;
          }
        }

        .box_centent_ul {
          display: flex;
          flex-wrap: wrap;
          padding: 0 0.8rem;
          border-bottom: 1px solid #a0a0a0;
          li {
            padding: 0.17rem 0;
            margin-right: 0.2rem;
            span {
              font-size: 0.25rem;
              color: #000101;
            }
            span:nth-of-type(1) {
              color: red;
              line-height: 0.25rem;
            }
            input {
              border: 1px solid #dcdfe6;
              border-radius: 0.05rem;
              height: 0.34rem;
              outline: none;
              width: 2.77rem;
              text-indent: 1em;
            }
          }

          li:nth-of-type(2) {
            input {
              width: 3.83rem;
            }
          }
          li:nth-of-type(4) {
            input {
              width: 1.55rem;
            }
          }
          li:nth-of-type(5) {
            input {
              width: 1.73rem;
            }
          }
        }
        .tianjia {
          margin-left: 50%;
          margin-top: 0.24rem;
          transform: translateX(-50%);
          margin-bottom: 0.1rem;
          text-align: center;
          color: #fff;
          background-color: #00a0e9;
          font-size: 0.27rem;
          border-radius: 0.22rem;
          width: 0.53rem;
          height: 0.44rem;
          line-height: 0.44rem;
        }
        .delList{
          width: 0.8rem;
          background-color:red;
        }
        .box_centent_uls {
          display: flex;
          flex-wrap: wrap;

          border-bottom: 1px solid #a0a0a0;
          li {
            padding: 0.17rem 0;
            margin-right: 0.2rem;
            span {
              font-size: 0.25rem;
              color: #000101;
            }
            span:nth-of-type(1) {
              color: red;
              line-height: 0.25rem;
            }
            input {
              border: 1px solid #dcdfe6;
              border-radius: 0.05rem;
              height: 0.34rem;
              outline: none;
              width: 2.77rem;
              text-indent: 1em;
            }
          }

          li:nth-of-type(2) {
            input {
              width: 3.83rem;
            }
          }
          li:nth-of-type(3) {
            input {
              width: 1.24rem;
            }
          }
          li:nth-of-type(4) {
            input {
              width: 1.91rem;
            }
          }
          li:nth-of-type(5) {
            input {
              width: 1.91rem;
            }
          }
        }
        .self_relation_ul {
          display: flex;
          flex-wrap: wrap;

          border-bottom: 1px solid #a0a0a0;
          li {
            padding: 0.17rem 0;
            margin-right: 0.2rem;
            span {
              font-size: 0.25rem;
              color: #000101;
            }
            span:nth-of-type(1) {
              color: red;
              line-height: 0.25rem;
            }
            input {
              border: 1px solid #dcdfe6;
              border-radius: 0.05rem;
              height: 0.34rem;
              outline: none;
              width: 2.77rem;
              text-indent: 1em;
            }
          }
          li:nth-of-type(2) {
            input {
              width: 5.29rem;
            }
          }
          li:nth-of-type(3) {
            input {
              width: 2.4rem;
            }
          }
          li:nth-of-type(4) {
            input {
              width: 2.7rem;
            }
          }
          li:nth-of-type(5) {
            input {
              width: 1.65rem;
            }
          }
        }
        .uploader_ul {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;

          li {
            width: 3.6rem;
            height: 2.46rem;
            border-radius: 0.1rem;
            margin-bottom: 0.8rem;
            .li_img_box {
              width: 3.6rem;
              height: 2.46rem;
              overflow: hidden;
            }
            p {
              font-size: 0.29rem;

              span {
                color: #ff0000;
              }
              span:nth-of-type(2) {
                color: #000101;
              }
            }
            .avatar-uploader {
              text-align: center;
              line-height: 2.46rem;
              .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
                overflow: hidden;
              }
              .el-upload:hover {
                border-color: #409eff;
              }
              .avatar-uploader-icon {
                font-size: 0.28rem;
                color: #8c939d;
                width: 1.78rem;
                height: 1.78rem;
                line-height: 1.78rem;
                text-align: center;
              }
              .avatar {
                width: 1.78rem;
                height: 1.78rem;
                display: block;
              }
            }
          }
        }
      }
      .sub {
        color: #fff;
        font-size: 0.76rem;
        font-weight: 600;
        background-color: red;
        padding: 0.19rem 0.4rem;
        text-align: center;
        margin-left: 50%;
        transform: translateX(-50%);
        border: none;
      }
    }
  }
}
</style>



